import React, { useEffect, useState } from 'react'
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { studentProfile } from '../json/StudentData';
const AddingStudent = () => {
    // const [firstName, setFirstName] = useState("");
    // const [middleName, setMiddleName] = useState("");
    // const [lastName, setLastName] = useState("");
    // const [dateOfBirth,setDateOfBirth] =useState("");
    // const [rollNo,setRollNo] = useState("");
    // const [studied,setStudied]=useState("");
    // const [studiedRoman,setStudiedRoman]=useState("");
    // const [classSection,setClassSection] = useState("");
    // const [category,setCategory] = useState("");
    // const [gender,setGender] = useState("");
    // const [studentCode,setStudentCode] = useState("");

  //   const Class =[
  //   {num:1,val:"I"},
  //   {num:2,val:"II"},
  //   {num:3,val:"III"},
  //   {num:4,val:"IV"},
  //   {num:5,val:"V"},
  //   {num:6,val:"VI"},
  //   {num:7,val:"VII"},
  //   {num:8,val:"VIII"},
  //   {num:9,val:"IX"},
  //   {num:10,val:"X"},
  //   {num:11,val:"XI"},
  //   {num:12,val:"XII"}, 
  // ]

    // useEffect(()=>{
    //   if(studied.length>0 && studied!=="null"){ const temp=Class.find((elem)=>elem.num===parseInt(studied)).val
    //    setStudiedRoman(temp);}
    //    else if(studied==="null"){ setStudiedRoman("Please Select Standard")}
    //   },[studied])

// console.log(studentProfile.length);


    // const addstudent = async () => {
    //   for(let i=0;i<studentProfile.length;i++)
    //   {
    //    const docref= await addDoc(collection(db, "admissionStudentList"), {
    //       aadhaarNumber:studentProfile[i]?.aadhaarNumber,
    //       admissionDate:studentProfile[i]?.admissionDate,
    //       admissionFee:studentProfile[i]?.admissionFee,
    //       bloodGroup:studentProfile[i]?.bloodGroup,
    //       boardType:studentProfile[i]?.boardType,
    //       category:studentProfile[i]?.category,
    //       studied: studentProfile[i]?.studied ,
    //       classSection: studentProfile[i]?.classSection ,
    //       csrTag:studentProfile[i]?.csrTag,
    //       dateOfBirth:studentProfile[i]?.dateOfBirth,
    //       emailId:studentProfile[i]?.emailId,
    //       fathersName:studentProfile[i]?.fathersName,
    //       fullName:studentProfile[i]?.fullName,
    //       gender:studentProfile[i]?.gender,
    //       house:studentProfile[i]?.house,
    //       mothersName:studentProfile[i]?.mothersName,
    //       nationality:studentProfile[i]?.nationality,
    //       newAdmission:studentProfile[i]?.newAdmission,
    //       phoneNumber:studentProfile[i]?.phoneNumber,
    //       physicalType:studentProfile[i]?.physicalType,
    //       religion:studentProfile[i]?.religion,
    //       rte:studentProfile[i]?.rte,
    //       schoolCode:studentProfile[i]?.schoolCode,
    //       schoolName:studentProfile[i]?.schoolName,
    //       stream:studentProfile[i]?.stream,
    //       studentAdmitClass:studentProfile[i]?.studentAdmitClass,
    //       studentIdNumber:studentProfile[i]?.studentIdNumber,
    //       studentPrevSchoolName:studentProfile[i]?.studentPrevSchoolName,
    //       studentPrevTc:studentProfile[i]?.studentPrevTc,
    //       studentPrevTcNumber:studentProfile[i]?.studentPrevTcNumber,
    //       studentRollNumber:studentProfile[i]?.studentRollNumber,
    //       studentType:studentProfile[i]?.studentType,
    //     })
    //     console.log(docref.id);
    //   }
    // };

  return (
    <div className="container">
    <div className="p-10 ">
      <div className="py-4  mb-2 ">
        <span className="text-4xl text-black font-bold">
           Add Students
        </span>

      </div>
      {/* <div className="py-4 px-8">
         <div className='grid grid-cols-2  gap-4'>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Class
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select
              onChange={(e)=>setStudied(e.target.value)}
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            ><option value="null">Please Select Standard</option>
              {Class.map((item,index)=>
              (<option value={item.num} key={index}>{item.num}</option>)
              )
              }
              </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Section
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select 
                    value={classSection}
                   onChange={(e) => {
                  setClassSection(e.target.value);
                           }}
                          className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Student ID
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      value={studentCode}
                      onChange={(e) => {
                        setStudentCode(e.target.value);
                      }}
                      type="text"
                      placeholder="Student ID"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                     />
                  </div>
                </div>
              </div>
              </div>
        <div className="grid grid-cols-3 gap-4">
          <div className="mb-4">
            <label className="block text-grey-darker text-sm font-bold mb-2">
              First Name
            </label>
            <input
              className=" border rounded w-full py-2 px-3 text-grey-darker"
              type="text"
              placeholder="Enter Your First Name "
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Middle Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Middle Name"
                value={middleName}
                onChange={(e) => {
                  setMiddleName(e.target.value);
                }}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Last Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Last Name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div className="mb-4">
            <label className="block text-grey-darker text-sm font-bold mb-2">
              First Name
            </label>
            <input
              className=" border rounded w-full py-2 px-3 text-grey-darker"
              type="text"
              placeholder="Enter Your First Name "
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Middle Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Middle Name"
                value={middleName}
                onChange={(e) => {
                  setMiddleName(e.target.value);
                }}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Last Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Last Name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 mt-6">
             <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Category
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select 
                    value={category}
                   onChange={(e) => {
                  setCategory(e.target.value);
                           }}
                          className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Schedule Caste">Schedule Caste</option>
                      <option value="Schedule Tribe">Schedule Tribe</option>
                      <option value="General">General</option>
                      <option value="OBC I">OBC I</option>
                      <option value="OBC II">OBC II</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Gender
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select 
                    value={gender}
                    onChange={(e) => {
                   setGender(e.target.value);
                            }}
                          className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="select"> select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
              </div>
        </div>
      
        <div className="grid grid-cols-2 gap-4">
        <div className="mb-4">
          <label className="block text-grey-darker text-sm font-bold mb-2">
            Roll No. :
          </label>
          <input
            className=" border rounded w-full py-2 px-3 text-grey-darker"
            type="text"
            placeholder="Roll No. "
            value={rollNo}
            onChange={(e) => {
              setRollNo
              (e.target.value);
            }}
          />
        </div>
        <div className="mb-4">
          <label className="block text-grey-darker text-sm font-bold mb-2">
          Date of Birth
          </label>
          <input
            className=" border rounded w-full py-2 px-3 text-grey-darker"
            type="date"
            placeholder="Date Of Birth"
            value={dateOfBirth}
            onChange={(e) => {
              setDateOfBirth
              (e.target.value);
            }}
          />
        </div>
         </div>
       
      </div> */}
      {/* <div className="mt-4 ">
        <button
          className="w-24 h-16 bg-blue-400  text-2xl text-white font-semibold"
          onClick={addstudent}
        >
          Submit
        </button>
      </div> */}
    </div>
  </div>  )
}

export default AddingStudent